/**
 * Custom Progressive Variant Picker for Thibaud Poirier Photography
 * Replaces the flat Dawn variant picker with a hierarchical selector:
 * 1. Finition category (Fine Art Print / Acrylic Glass / Shadowbox / Framed)
 * 2. Sub-options (Glossy/Matte, Frame color, Glass type)
 * 3. Size (only available sizes for the selected configuration)
 */

(function () {
  'use strict';

  // -- Configuration hierarchy --
  var FINITION_CATEGORIES = [
    {
      id: 'fine-art',
      label: 'Fine Art Print',
      description: 'Tirage Fine Art sur papier d\'art',
      subOptions: [
        { id: 'glossy', label: 'Glossy', configValue: 'Fine Art Paper Print - Glossy' },
        { id: 'matte', label: 'Matte', configValue: 'Fine Art Paper Print - Matte' }
      ]
    },
    {
      id: 'acrylic',
      label: 'Acrylic Glass',
      description: 'Tirage photo sous verre acrylique',
      subOptions: [
        { id: 'glossy', label: 'Glossy', configValue: 'Photo Print Under Acrylic Glass - Glossy' },
        { id: 'matte', label: 'Matte', configValue: 'Photo Print Under Acrylic Glass - Matte' }
      ]
    },
    {
      id: 'shadowbox',
      label: 'Shadowbox',
      description: 'Verre acrylique en caisse am\u00e9ricaine noire',
      subOptions: [
        { id: 'glossy', label: 'Glossy', configValue: 'Photo Print Under Acrylic Glass - Glossy - Black Shadowbox' },
        { id: 'matte', label: 'Matte', configValue: 'Photo Print Under Acrylic Glass - Matte - Black Shadowbox' }
      ]
    },
    {
      id: 'framed',
      label: 'Framed Fine Art Print',
      description: 'Tirage Fine Art encadr\u00e9',
      hasFrameOptions: true,
      hasGlassOptions: true,
      frames: [
        { id: 'white', label: 'White' },
        { id: 'black', label: 'Black' },
        { id: 'oak', label: 'Oak' }
      ],
      glassTypes: [
        { id: 'standard', label: 'Standard Glass' },
        { id: 'museum', label: 'Museum Glass' }
      ],
      getConfigValue: function (frameId, glassId) {
        var frameMap = { white: 'White Frame', black: 'Black Frame', oak: 'Oak Frame' };
        var framePart = frameMap[frameId];
        if (glassId === 'museum') {
          return 'Framed Fine Art Print - ' + framePart + ' - Museum Glass';
        }
        return 'Framed Fine Art Print - ' + framePart;
      }
    }
  ];

  // -- State --
  var state = {
    category: null,
    subOption: null,
    frame: null,
    glass: null,
    size: null,
    configValue: null
  };

  var variantData = [];
  var applyTimeout = null;

  // -- Init --
  function init() {
    if (!getLivePicker()) return;

    loadVariantData().then(function () {
      buildCustomPicker();
      selectCategory('fine-art');
    });
  }

  function loadVariantData() {
    var productInfo = document.querySelector('product-info');
    var productUrl = productInfo ? productInfo.dataset.url : window.location.pathname;
    return fetch(productUrl + '.json')
      .then(function (resp) { return resp.json(); })
      .then(function (data) {
        variantData = data.product.variants.map(function (v) {
          return {
            id: v.id,
            size: v.option1,
            config: v.option2,
            price: v.price,
            available: v.available !== false
          };
        });
      })
      .catch(function (e) {
        console.error('Failed to load variant data', e);
      });
  }

  // -- Build UI --
  function buildCustomPicker() {
    var picker = getLivePicker();
    if (!picker) return;
    hideNativeFieldsets();

    var container = document.createElement('div');
    container.id = 'tp-variant-picker';
    container.innerHTML =
      '<div class="tp-picker-section" id="tp-category-section">' +
        '<label class="tp-picker-label">Finition</label>' +
        '<div class="tp-picker-options" id="tp-categories"></div>' +
      '</div>' +
      '<div class="tp-picker-section tp-hidden" id="tp-suboption-section">' +
        '<label class="tp-picker-label" id="tp-suboption-label">Finish</label>' +
        '<div class="tp-picker-options" id="tp-suboptions"></div>' +
      '</div>' +
      '<div class="tp-picker-section tp-hidden" id="tp-frame-section">' +
        '<label class="tp-picker-label">Frame</label>' +
        '<div class="tp-picker-options" id="tp-frames"></div>' +
      '</div>' +
      '<div class="tp-picker-section tp-hidden" id="tp-glass-section">' +
        '<label class="tp-picker-label">Glass</label>' +
        '<div class="tp-picker-options" id="tp-glasses"></div>' +
      '</div>' +
      '<div class="tp-picker-section tp-hidden" id="tp-size-section">' +
        '<label class="tp-picker-label">Size</label>' +
        '<div class="tp-picker-options" id="tp-sizes"></div>' +
      '</div>';

    picker.parentNode.insertBefore(container, picker);
    renderCategories();
  }

  function renderCategories() {
    var container = document.getElementById('tp-categories');
    container.innerHTML = '';
    FINITION_CATEGORIES.forEach(function (cat) {
      var btn = createOptionButton(cat.label, cat.id, function () { selectCategory(cat.id); });
      container.appendChild(btn);
    });
  }

  function renderSubOptions(category) {
    var section = document.getElementById('tp-suboption-section');
    var container = document.getElementById('tp-suboptions');
    container.innerHTML = '';

    if (category.subOptions) {
      section.classList.remove('tp-hidden');
      document.getElementById('tp-suboption-label').textContent = 'Finish';
      category.subOptions.forEach(function (opt) {
        var btn = createOptionButton(opt.label, opt.id, function () { selectSubOption(opt.id); });
        container.appendChild(btn);
      });
    } else {
      section.classList.add('tp-hidden');
    }
  }

  function renderFrameOptions(category) {
    var section = document.getElementById('tp-frame-section');
    var container = document.getElementById('tp-frames');
    container.innerHTML = '';

    if (category.hasFrameOptions) {
      section.classList.remove('tp-hidden');
      category.frames.forEach(function (frame) {
        var btn = createOptionButton(frame.label, frame.id, function () { selectFrame(frame.id); });
        container.appendChild(btn);
      });
    } else {
      section.classList.add('tp-hidden');
    }
  }

  function renderGlassOptions(category) {
    var section = document.getElementById('tp-glass-section');
    var container = document.getElementById('tp-glasses');
    container.innerHTML = '';

    if (category.hasGlassOptions) {
      section.classList.remove('tp-hidden');
      category.glassTypes.forEach(function (glass) {
        var btn = createOptionButton(glass.label, glass.id, function () { selectGlass(glass.id); });
        container.appendChild(btn);
      });
    } else {
      section.classList.add('tp-hidden');
    }
  }

  function renderSizes() {
    var section = document.getElementById('tp-size-section');
    var container = document.getElementById('tp-sizes');
    container.innerHTML = '';

    if (!state.configValue) {
      section.classList.add('tp-hidden');
      return;
    }

    var availableSizes = variantData
      .filter(function (v) { return v.config === state.configValue && v.available; })
      .map(function (v) { return v.size; });

    if (availableSizes.length === 0) {
      section.classList.add('tp-hidden');
      return;
    }

    section.classList.remove('tp-hidden');

    var sortedSizes = availableSizes.sort(function (a, b) {
      return parseInt(a) - parseInt(b);
    });

    sortedSizes.forEach(function (size) {
      var variant = variantData.find(function (v) {
        return v.config === state.configValue && v.size === size;
      });
      var priceText = variant ? formatPrice(variant.price) : '';
      var btn = createOptionButton(size, size, function () { selectSize(size); }, priceText);
      container.appendChild(btn);
    });

    if (!state.size || !availableSizes.includes(state.size)) {
      selectSize(sortedSizes[0]);
    } else {
      setActiveButton('tp-sizes', state.size);
      applySelection();
    }
  }

  // -- Selection handlers --
  function selectCategory(categoryId) {
    state.category = categoryId;
    state.subOption = null;
    state.frame = null;
    state.glass = null;
    state.size = null;
    state.configValue = null;

    setActiveButton('tp-categories', categoryId);

    var category = FINITION_CATEGORIES.find(function (c) { return c.id === categoryId; });

    document.getElementById('tp-suboption-section').classList.add('tp-hidden');
    document.getElementById('tp-frame-section').classList.add('tp-hidden');
    document.getElementById('tp-glass-section').classList.add('tp-hidden');
    document.getElementById('tp-size-section').classList.add('tp-hidden');

    if (category.hasFrameOptions) {
      renderFrameOptions(category);
      renderGlassOptions(category);
      selectFrame('white');
    } else {
      renderSubOptions(category);
      if (category.subOptions && category.subOptions.length > 0) {
        selectSubOption(category.subOptions[0].id);
      }
    }
  }

  function selectSubOption(optionId) {
    state.subOption = optionId;
    setActiveButton('tp-suboptions', optionId);

    var category = FINITION_CATEGORIES.find(function (c) { return c.id === state.category; });
    var subOpt = category.subOptions.find(function (o) { return o.id === optionId; });
    state.configValue = subOpt.configValue;

    renderSizes();
  }

  function selectFrame(frameId) {
    state.frame = frameId;
    setActiveButton('tp-frames', frameId);

    if (!state.glass) {
      selectGlass('standard');
    } else {
      updateFramedConfigValue();
      renderSizes();
    }
  }

  function selectGlass(glassId) {
    state.glass = glassId;
    setActiveButton('tp-glasses', glassId);

    updateFramedConfigValue();
    renderSizes();
  }

  function updateFramedConfigValue() {
    if (state.frame && state.glass) {
      var category = FINITION_CATEGORIES.find(function (c) { return c.id === 'framed'; });
      state.configValue = category.getConfigValue(state.frame, state.glass);
    }
  }

  function selectSize(size) {
    state.size = size;
    setActiveButton('tp-sizes', size);
    applySelection();
  }

  // -- Get live reference to variant-selects (Dawn may replace the element) --
  function getLivePicker() {
    return document.querySelector('variant-selects');
  }

  // -- Hide Dawn's native fieldsets (must re-apply after Dawn re-renders) --
  function hideNativeFieldsets() {
    var picker = getLivePicker();
    if (!picker) return;
    picker.querySelectorAll('fieldset').forEach(function (fs) {
      fs.style.display = 'none';
    });
  }

  // -- Apply selection to Dawn's native picker (with debounce) --
  function applySelection() {
    if (!state.configValue || !state.size) return;

    clearTimeout(applyTimeout);

    var targetConfig = state.configValue;
    var targetSize = state.size;

    applyTimeout = setTimeout(function () {
      var livePicker = getLivePicker();
      if (!livePicker) return;

      var radios = livePicker.querySelectorAll('input[type="radio"]');

      // Step 1: Click Configuration radio
      radios.forEach(function (radio) {
        if (radio.name.trim().startsWith('Configuration') && radio.value === targetConfig) {
          if (radio.checked) {
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            radio.click();
          }
        }
      });

      // Step 2: Click Size radio (re-query because Dawn re-renders Size fieldset after Config change)
      setTimeout(function () {
        var freshPicker = getLivePicker();
        if (!freshPicker) return;
        var freshRadios = freshPicker.querySelectorAll('input[type="radio"]');
        freshRadios.forEach(function (radio) {
          if (radio.name.trim().startsWith('Size') && radio.value === targetSize) {
            if (radio.checked) {
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              radio.click();
            }
          }
        });
        // Re-hide fieldsets after Dawn re-renders them
        hideNativeFieldsets();
      }, 50);
    }, 150);
  }

  // -- UI Helpers --
  function createOptionButton(label, dataId, onClick, sublabel) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tp-option-btn';
    btn.dataset.id = dataId;
    if (sublabel) {
      btn.innerHTML = '<span class="tp-btn-label">' + label + '</span>';
    } else {
      btn.textContent = label;
    }
    btn.addEventListener('click', onClick);
    return btn;
  }

  function setActiveButton(containerId, activeId) {
    var container = document.getElementById(containerId);
    if (!container) return;
    container.querySelectorAll('.tp-option-btn').forEach(function (btn) {
      btn.classList.toggle('tp-active', btn.dataset.id === activeId);
    });
  }

  function formatPrice(price) {
    var num = parseFloat(price);
    return num.toLocaleString('fr-FR') + ' \u20ac';
  }

  // -- Start --
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();